import React from 'react';
import p1 from '../images/house2.jpeg';
import p2 from '../images/house3.jpeg';
import p3 from '../images/house6.jfif';
import p4 from '../images/house5.jpeg';
import p5 from '../images/house7.jfif';
import p6 from '../images/house4.jpeg';

function ProjectsPage() {
    return (
        <div className="projects-cont" id="portfolio" style={{fontFamily: 'Roboto',fontWeight: '400'}} >
                <div className="PageIntroBanner_header" ><div className="row p-lg-5 proj-head" style={{marginRight:"15px"}}>
              <div className="col-lg-10 mx-auto text-center"><h3 style={{ marginTop: "-70px" ,color:"#002856"}}>What we build.</h3></div></div>
          </div>
           
              <div className="cards-cont">
               <div className="card-deck justify-content-center mb-3">
                    <div className="card col-sm-2">
                        <img className="card-img-top" src={p1} alt="Card image cap" />
                        
                    </div>
                    <div className="card col-sm-2">
                      
                        <img className="card-img-top" src={p2} alt="Card image cap" />
                          
                    </div>
                    <div className="card col-sm-2">
                        <img className="card-img-top" src={p3} alt="Card image cap" />
                        
                    </div>
                    </div>
                    <div className="card-deck justify-content-center mb-3">
                    <div className="card col-sm-2">
                        <img className="card-img-top" src={p4} alt="Card image cap" />
                        
                    </div>
                    <div className="card col-sm-2">
                        <img className="card-img-top" src={p5} alt="Card image cap" />
                        
                    </div>
                    <div className="card col-sm-2">
                        <img className="card-img-top" src={p6} alt="Card image cap" />
                       
                    </div>
                    </div>
                </div>
                
           
        </div>
    );

}

export default ProjectsPage;